import { createAction as createReduxAction } from 'redux-actions'

export const PENDING = type => `${type}_PENDING`
export const FULFILLED = type => `${type}_FULFILLED`
export const REJECTED = type => `${type}_REJECTED`

export const createAction = type => createReduxAction(type)
export const createAsyncAction = type => createReduxAction(type, async data => data)
